export default __webpack_public_path__ + "static/media/001-couple-3.7a877da9.png";